module.exports = __webpack_public_path__ + "img/goods10_3.ec5c5aaa.jpg";